// extracted by mini-css-extract-plugin
module.exports = {"statistics":"Statistics_statistics__3VHyO","title":"Statistics_title__2oxCh","statList":"Statistics_statList__3STJy","item":"Statistics_item__1_saC"};